export const NEWS_AUTHOR = 'CTRL Media';

export const newsPosts = [
  {
    slug: 'ctrl-systems-announces-authorized-distributorship-with-avionteq-at-nbaa-bace-2026',
    pdf: '/docs/ctrl-systems-announces-authorized-distributorship-with-avionteq-at-nbaa-bace-2026.pdf',
    metaDescription: 'CTRL Systems names AvionTEq an authorized distributor of the UL101 Aviation Troubleshooter and CTRL acoustic cameras, announced at NBAA-BACE 2026.',
    title: 'CTRL Systems Announces Authorized Distributorship Agreement with AvionTEq at NBAA-BACE 2026',
    date: '2026-10-20',
    category: 'Partnerships',
    image: '/images/img_0291.jpeg',
    imageAlt: 'CTRL Systems UL101 Aviation Troubleshooter kit',
    excerpt:
      'CTRL Systems has signed an agreement naming AvionTEq, a global provider of aviation test equipment, an authorized distributor of the UL101 Aviation Troubleshooter and CTRL\u2019s acoustic imaging cameras.',
    body: [
      { type: 'small', text: 'FOR IMMEDIATE RELEASE' },
      {
        type: 'p',
        text:
          'WESTMINSTER, MD; VAN NUYS, CA \u2014 October 20, 2026 \u2014 CTRL Systems, Inc., a developer of acoustic ultrasound technology, today announced that it has signed an agreement with AvionTEq, a global provider of aviation test equipment and support solutions, naming AvionTEq an authorized distributor of CTRL Systems products.',
      },
      {
        type: 'p',
        text:
          'The announcement coincides with the 2026 NBAA Business Aviation Convention & Exhibition (NBAA-BACE), taking place October 20\u201322 in Las Vegas, Nevada. AvionTEq is exhibiting at Booth #2625.',
      },
      {
        type: 'p',
        text:
          'The agreement adds CTRL Systems\u2019 acoustic ultrasound solutions to AvionTEq\u2019s aviation maintenance and troubleshooting portfolio, including the UL101 Aviation Troubleshooter and a range of acoustic imaging cameras.',
      },
      {
        type: 'p',
        text:
          'The UL101 Aviation Troubleshooter (P/N B00033), identified in Boeing tooling references as SPL-1473, helps aircraft maintenance technicians locate ultrasonic sound associated with leaks in applications such as pitot-static, cabin pressurization, bleed air, and oxygen systems. By helping technicians pinpoint leak sources, the UL101 supports efficient troubleshooting within applicable aircraft maintenance procedures.',
      },
      {
        type: 'p',
        text:
          'Complementing the UL101, CTRL\u2019s portfolio of acoustic cameras visualizes ultrasonic sound in real time to help technicians locate leak sources. These cameras meet or exceed the technical requirements referenced by Boeing tool designation COM-18702 (Digital Camera \u2013 Acoustic) and are offered as functional equivalents under operator tool-equivalency programs, subject to the operator\u2019s applicable documentation and quality approval.',
      },
      {
        type: 'p',
        text:
          'Together, the UL101 handheld sensor and an acoustic camera provide a full ultrasonic troubleshooting solution, combining visual scanning to locate suspect areas with focused listening and precise fault isolation. This complementary approach helps maintenance teams move from an initial survey to detailed investigation within applicable aircraft maintenance procedures.',
      },
      {
        type: 'quote',
        text:
          'Aircraft maintenance teams need practical tools that help them pinpoint problems and make better use of troubleshooting time. Our partnership with AvionTEq brings the UL101 handheld sensor and our portfolio of acoustic cameras to a broader aviation audience through an established test equipment provider. We look forward to working together to help more technicians put acoustic ultrasound to work in their maintenance operations.',
        cite: 'Jeremy Watts, Vice President, Technical Sales & Business Development, CTRL Systems',
      },
      {
        type: 'quote',
        text:
          'By adding CTRL Systems to our portfolio, we sharpen our customers\u2019 access to innovative tools that increase troubleshooting efficiency and decrease aircraft downtime. We are excited to bring CTRL Systems\u2019 solutions to a broader aviation customer base worldwide.',
        cite: 'Fred Bostani, CEO, AvionTEq',
      },
      {
        type: 'p',
        text:
          'NBAA-BACE attendees are invited to visit AvionTEq at Booth #2625 to meet the team and learn more about its aviation test equipment and support solutions. AvionTEq will also conduct a UTS100 ULB Tester raffle during the event. Visitors can stop by the booth for entry details.',
      },
      { type: 'h2', text: 'About CTRL Systems' },
      {
        type: 'p',
        text:
          'CTRL Systems, Inc. develops acoustic ultrasound technologies for leak detection, troubleshooting, condition monitoring, and maintenance applications across aviation and other industries. For more information, visit https://ctrl.aero.',
      },
      { type: 'h2', text: 'About AvionTEq' },
      {
        type: 'p',
        text:
          'AvionTEq is a global provider of aviation and avionics test equipment based at Van Nuys Airport in California. The company supports airlines, MROs, aircraft manufacturers, military and government organizations, and business aviation operators worldwide with new and refurbished equipment sales, rentals, trade-ins, repair and calibration support, and technical support services. For more information, visit https://www.avionteq.com.',
      },
      { type: 'h2', text: 'CTRL Media Contact' },
      {
        type: 'contact',
        lines: [
          'Jeremy Watts',
          'Vice President, Technical Sales & Business Development, Aviation GSTE',
          'CTRL Systems, Inc. | ctrl.aero',
          'jwatts@ctrlsys.com',
          '+1 (410) 840.4861',
        ],
      },
      { type: 'h2', text: 'AvionTEq Media Contact' },
      {
        type: 'contact',
        lines: [
          'Mei Antiporda',
          'Sourcing and Marketing Solutions Specialist',
          'AvionTEq',
          'marketing@avionteq.com',
          '310-649-0400 ext. 356',
        ],
      },
    ],
  },
  {
    slug: 'ctrl-systems-names-jeremy-watts-vice-president-of-sales-business-development',
    metaDescription: 'CTRL Systems promotes Jeremy Watts to Vice President of Sales & Business Development after leading growth in aerospace maintenance.',
    title: 'CTRL Systems Names Jeremy Watts Vice President of Sales & Business Development',
    date: '2025-07-15',
    category: 'Company News',
    image: '/images/news/watts-vp.jpg',
    imageAlt: 'Jeremy Watts, Vice President of Sales & Business Development, CTRL Systems',
    excerpt:
      'Jeremy Watts, a key contributor to CTRL Systems\u2019 recent success in the aerospace maintenance sector, has been promoted to Vice President of Sales & Business Development, effective immediately.',
    body: [
      { type: 'small', text: 'FOR IMMEDIATE RELEASE' },
      {
        type: 'p',
        text:
          'WESTMINSTER, MD \u2014 July 15, 2025 \u2014 CTRL Systems Inc., a globally recognized innovator in ultrasound-based sensing solutions for the aerospace and industrial sectors, today announced a significant strategic leadership transition designed to further strengthen its market position and accelerate growth.',
      },
      {
        type: 'p',
        text:
          'Jeremy Watts, a key contributor to CTRL Systems\u2019 recent success in the aerospace maintenance sector, has been promoted to Vice President of Sales & Business Development, effective immediately. Watts has been with CTRL Systems since 2012, where he served as Director of Business Development for Aviation & Aerospace since 2021. This crucial vertical market has seen significant growth under his direction, as he has forged valuable partnerships with industry leaders such as Boeing, Barfield, Southwest Airlines, and Fluke. The enthusiastic adoption of CTRL technologies into the commercial and military aviation markets has demonstrated the critical value of CTRL\u2019s advanced ultrasound technology in ensuring operational efficiency, fleet readiness, and aircraft safety within the highly regulated aerospace industry.',
      },
      {
        type: 'p',
        text:
          'In addition to his primary focus in the aviation maintenance market, Watts will assume a pivotal leadership role within CTRL\u2019s industrial sales team. His proven expertise in identifying market opportunities, fostering strategic partnerships, and driving revenue growth will be instrumental in expanding CTRL\u2019s footprint across diverse industrial applications, including manufacturing, energy, and infrastructure. This expanded role underscores CTRL Systems\u2019 commitment to leveraging its cutting-edge technology to provide comprehensive solutions across a wider range of industries.',
      },
      {
        type: 'quote',
        text:
          'We are excited about Jeremy\u2019s promotion to Vice President of Sales & Business Development. Jeremy has demonstrated exceptional leadership, strategic acumen, and an unwavering commitment to our customers, our partners, and our mission. His deep understanding of the aerospace and industrial markets, coupled with his ability to build strong relationships, makes him the ideal candidate to drive our continued growth and innovation.',
        cite: 'Robert Roche, Founder and CEO, CTRL Systems',
      },
      {
        type: 'quote',
        text:
          'The best days for CTRL Systems are ahead of us. Our organization is poised for significant growth across several verticals, starting with aviation. As our engineering capabilities and product portfolio continue to expand, I look forward to driving CTRL\u2019s continued success alongside the rest of the leadership team.',
        cite: 'Jeremy Watts',
      },
      {
        type: 'p',
        text:
          'This leadership transition is a testament to CTRL Systems\u2019 ongoing commitment to cultivating internal talent and strategically positioning itself for sustained success in the rapidly evolving ultrasound technology market. The company looks forward to a future of continued innovation and market leadership under its strengthened leadership team.',
      },
      { type: 'h2', text: 'About CTRL Systems Inc.' },
      {
        type: 'p',
        text:
          'Founded in 1989 and based in Westminster, Maryland, CTRL Systems are The Ultrasound Experts. CTRL designs and manufactures advanced ultrasound sensors and software for the aerospace, military, and industrial markets. With a strong focus on agile innovation, CTRL Systems delivers cutting-edge technology that empowers organizations to quickly troubleshoot faults, detect potential maintenance issues, and optimize machine performance. Serving both the demanding aerospace and military sectors, as well as a wide array of industrial applications, CTRL Systems is committed to delivering innovative solutions, superior products, and unparalleled customer support.',
      },
      { type: 'h2', text: 'Contact' },
      {
        type: 'contact',
        lines: [
          'CTRL Systems, Inc.',
          '1004 Littlestown Pike, Suite H',
          'Westminster, MD 21157',
          'Phone: +1 (410) 876-5676',
          'Email: info@ctrlsys.com',
        ],
      },
    ],
  },
  {
    slug: 'ctrl-systems-signs-distribution-agreement-with-fotric',
    metaDescription: 'CTRL Systems signs an agreement to distribute Fotric ultrasound acoustic cameras in the United States and Mexico.',
    title:
      'CTRL Systems, Inc. Signs Distribution Agreement with Fotric, Inc. to Become a Distributor of Fotric\u2019s Ultrasound Products in the United States and Mexico',
    date: '2025-03-03',
    category: 'Partnerships',
    image: '/images/news/fotric-h6.png',
    imageAlt: 'FOTRIC H6 ultrasound acoustic camera',
    imageFit: 'contain',
    excerpt:
      'CTRL Systems has signed an agreement with Fotric, a leading manufacturer of thermal imaging and ultrasound acoustic cameras, to distribute Fotric\u2019s ultrasound acoustic cameras in the United States and Mexico.',
    body: [
      {
        type: 'p',
        text:
          'CTRL Systems has signed an agreement with Fotric, a leading manufacturer of thermal imaging and ultrasound acoustic cameras for the industrial safety equipment sector. Fotric and CTRL have been at the forefront of development for quality signals in their respective fields. Fotric\u2019s newly developed ultrasound acoustic cameras have superior quality and performance with enhanced features and will be a welcome addition to CTRL\u2019s ultrasound offering.',
      },
      {
        type: 'p',
        text:
          'The CTRL ultrasound detectors, manufactured in the United States by CTRL Systems, give reliability engineers and maintenance technicians greater insight into the operating conditions of mechanical, pneumatic, hydraulic, and electrical systems. CTRL ultrasound detector products and software have been used by operators around the world to successfully troubleshoot production equipment and systems to mitigate unplanned downtime and save energy.',
      },
      {
        type: 'quote',
        text:
          'CTRL Systems extensively tested and has recognized the quality and performance of the Fotric cameras. We are excited to partner with Fotric due to our synergistic approach to only commercializing new ideas.',
        cite: 'Robert Roche, President, CTRL Systems, Inc.',
      },
      {
        type: 'quote',
        text:
          'The Fotric technology is simply not a repeat of other camera technology. We are committed to meeting the needs of our customers by providing a full solution to condition-based monitoring and leak detection with the added features and functionalities available in the next generation of ultrasound technology. We are excited to include Fotric\u2019s novel digital technologies as we continue to design and manufacture ultrasound solutions to solve specific applicational problems.',
        cite: 'Benjamin Fried, Vice President of Sales and Marketing, CTRL Systems',
      },
      {
        type: 'quote',
        text:
          'CTRL Systems has offered professional ultrasound solutions to industries for decades. We are honored to integrate FOTRIC\u2019s ultrasound acoustic and infrared thermal imagers into CTRL\u2019s solutions. I believe that by working together, we can better serve our customers and create greater value for them.',
        cite: 'Jim Zhao, CEO, Fotric Inc.',
      },
      { type: 'h2', text: 'About CTRL Systems' },
      {
        type: 'p',
        text:
          'CTRL Systems, Inc. are the Ultrasound Experts. Since 1989, CTRL has specialized in the design, manufacture, and integration of ultrasound-based hardware and software solutions for aircraft maintenance, condition-based monitoring, quality control, energy savings, and industrial reliability. CTRL\u2019s mission is to help our customers understand, integrate, and rely upon acoustic ultrasound technology to make critical maintenance decisions throughout all levels of their organization. CTRL ultrasound technology is in regular use by customers around (and orbiting) the globe, including NASA, the United States Military, and thousands of commercial and governmental organizations throughout the world.',
      },
      { type: 'h2', text: 'About Fotric, Inc.' },
      {
        type: 'p',
        text:
          'FOTRIC Inc. specializes in innovative sensing solutions for a wide range of industrial safety applications. Serving over 50 countries, its expertise extends to defect detection, condition monitoring, and safety assurance in sectors like manufacturing, chemical processing, metallurgy, storage of coal and Li-ion batteries, waste management, electric utilities, oil & gas, and building infrastructure. For more information about Fotric, please visit https://www.fotric.com.',
      },
    ],
  },
  {
    slug: 'ctrl-systems-improving-industrial-maintenance-since-1989',
    metaDescription: 'Founded by Bob Roche in 1989, CTRL Systems has led acoustic ultrasound innovation for NASA, the U.S. Navy, and commercial aviation.',
    title: 'CTRL Systems: Improving Industrial Maintenance Since 1989',
    date: '2024-09-23',
    category: 'Company News',
    image: '/images/news/since-1989.jpg',
    imageAlt: 'CTRL Systems acoustic ultrasound technology in use',
    excerpt:
      'In the world of industrial maintenance, one name has been synonymous with innovation for over thirty years: CTRL Systems. Founded by CEO Bob Roche, CTRL has been at the forefront of acoustic ultrasound technology.',
    body: [
      {
        type: 'p',
        text:
          'In the world of industrial maintenance, one name has been synonymous with innovation for over thirty years: CTRL Systems. Founded by our visionary CEO, Bob Roche, we\u2019ve been at the forefront of acoustic ultrasound technology.',
      },
      { type: 'h2', text: 'From Vision to Reality' },
      {
        type: 'p',
        text:
          'When Bob Roche founded CTRL Systems 35 years ago, he had a clear vision: to develop advanced acoustic ultrasound solutions that would redefine how organizations approach maintenance. Today, that vision has far exceeded expectations.',
      },
      {
        type: 'p',
        text:
          'Today, CTRL Systems proudly serves a wide range of industries, from aerospace to manufacturing, delivering state-of-the-art predictive maintenance technologies that keep businesses running smoothly and efficiently.',
      },
      { type: 'h2', text: 'Transforming Industrial Maintenance' },
      {
        type: 'p',
        text:
          'We\u2019re not just keeping pace with technology but defining its future. At the heart of everything we do is a simple yet powerful goal: to improve condition-based monitoring technology so organizations can understand, integrate, and depend upon it to make informed, critical business decisions.',
      },
      {
        type: 'p',
        text:
          'We believe that true predictive maintenance isn\u2019t just about preventing failures. It\u2019s about optimizing operations, reducing costs, and increasing overall efficiency. Our advanced sensors and AI/ML capabilities can detect the slightest anomalies and diagnose potential issues with unprecedented accuracy. By providing clear, actionable insights, we empower our clients to take control of their maintenance strategies and drive their businesses forward.',
      },
      { type: 'h2', text: 'Why CTRL Systems Stands Out' },
      {
        type: 'list',
        items: [
          'Trusted by NASA: Our technology is used on the International Space Station, proving its reliability in the most demanding environments.',
          'Naval Expertise: We\u2019ve developed robust solutions for subsea Naval platforms, demonstrating our ability to perform in challenging conditions.',
          'Aviation Innovation: Our tailored solutions address unique challenges in commercial aviation, enhancing safety and efficiency.',
        ],
      },
      { type: 'h2', text: 'Looking to the Future' },
      {
        type: 'p',
        text:
          'Get ready for takeoff as we launch a new era of predictive maintenance. With CTRL Systems, the future of industrial maintenance is here. It\u2019s more intelligent, more efficient, and more reliable than ever before.',
      },
    ],
  },
  {
    slug: 'ctrl-systems-signs-agreement-with-afi-klm-em-subsidiary-barfield-as-primary-global-distributor-of-ul101',
    metaDescription: 'CTRL Systems names Barfield, an AFI KLM E&M subsidiary, primary global distributor of the UL101 Aviation Troubleshooter test set.',
    title:
      'CTRL Systems Signs Agreement with AFI KLM E&M American Subsidiary, Barfield, to Act as the Primary Global Distributor of CTRL\u2019s UL101 Aviation Troubleshooter Test Set',
    date: '2024-04-09',
    category: 'Partnerships',
    image: '/images/news/barfield-signing.jpg',
    imageAlt: 'Barfield and CTRL executives shaking hands after signing the UL101 distribution agreement',
    imageCaption:
      'From left: Sebastien Losy (Barfield VP of GSTE, Distribution & Trading); Gilles Mercier (Barfield CEO); Jeremy Watts (CTRL Systems Global Director of Business Development, Aerospace & Aviation GSTE); and Victor Bontorno (Barfield Director of Business Development, GSTE)',
    excerpt:
      'CTRL Systems has signed an agreement with Barfield Inc., a subsidiary of Air France Industries KLM Engineering & Maintenance, to distribute the UL101 Aviation Troubleshooter ultrasonic test set to the commercial and business aviation markets worldwide.',
    body: [
      {
        type: 'p',
        text:
          'WESTMINSTER, MD; PARIS; AMSTELVEEN; MIAMI, FL \u2014 April 9, 2024 \u2014 CTRL Systems, Inc. has signed an agreement with Barfield Inc., a subsidiary of Air France Industries KLM Engineering & Maintenance (AFI KLM E&M) in the Americas, to distribute CTRL\u2019s UL101 Aviation Troubleshooter ultrasonic test set. Barfield will act as CTRL Systems\u2019 primary distributor to the commercial and business aviation markets, encompassing airline operators, aircraft and component OEMs, and MROs around the world.',
      },
      {
        type: 'quote',
        text:
          'We are excited about our partnership with CTRL Systems. The UL101 Aviation Troubleshooter couldn\u2019t enter the aviation maintenance market at a better moment. It will complement our line of distributed Ground Support Test Equipment. CTRL Systems\u2019 trust in Barfield to help bring solutions to customers is a testament to the quality of work our talented team puts in daily to ensure those aircraft take advantage of this technology.',
        cite: 'Gilles Mercier, Chief Executive Officer, Barfield',
      },
      {
        type: 'quote',
        text:
          'Barfield\u2019s commitment to providing the best services to their customers aligns strategically with our mission to help aircraft operators, MROs, and OEMs to understand, integrate, and rely upon acoustic technology.',
        cite: 'Robert Roche, President and CEO, CTRL Systems',
      },
      {
        type: 'quote',
        text:
          'The Barfield name is synonymous with aviation history and innovation. Our company is honored to partner with such a storied brand. I look forward to working together with Barfield\u2019s world-class GSTE division to help their customers effectively integrate CTRL ultrasound technology as an essential component throughout all levels of their maintenance operations.',
        cite: 'Jeremy Watts, Global Director of Business Development for Aerospace and Aviation, CTRL Systems',
      },
      {
        type: 'p',
        text:
          'The UL101 Aviation Troubleshooter, manufactured in the United States by CTRL Systems, gives aircraft maintenance technicians greater insight into the operating conditions of the aircraft systems under test. The UL101 Aviation Troubleshooter has been used by operators around the world to successfully accelerate the AOG troubleshooting process, minimizing both aircraft downtime and the cost of replacement parts. The UL101 Aviation Troubleshooter (P/N B00033) is referenced in the Boeing AMM for all commercial jet aircraft under the tool tag SPL-1473.',
      },
      {
        type: 'p',
        text:
          'CTRL\u2019s ultrasonic listening devices \u2014 including the UL101 Aviation Troubleshooter \u2014 detect acoustic ultrasound at 40 kHz and convert the signal into the audible range, outputting it to an included headset or available software. In the aircraft maintenance field, this technology is used to pinpoint leaks in a variety of aircraft systems, including cabin pressurization, O2 systems, pitot/static systems, bleed/engine air systems, and A/C packs. It is also used to detect electrical faults and intermittent wiring issues, to troubleshoot failing mechanical components, to detect internal fluid leaks, and to quickly perform valve inspections.',
      },
      { type: 'h2', text: 'About CTRL Systems, Inc.' },
      {
        type: 'p',
        text:
          'CTRL Systems, Inc. are the Ultrasound Experts. Since 1989, CTRL has specialized in the design, manufacture, and integration of ultrasound-based hardware and software solutions for aircraft maintenance, condition-based monitoring, quality control, energy savings, and industrial reliability. CTRL\u2019s mission is to help our customers understand, integrate, and rely upon acoustic ultrasound technology to make critical maintenance decisions throughout all levels of their organization. CTRL ultrasound technology is currently in regular use by over 3,000 customers around (and orbiting) the globe, including NASA, the United States Navy, the United States Air Force, Boeing, Lockheed Martin, Northrop Grumman, Southwest Airlines, and Collins Aerospace. CTRL Systems is proudly headquartered in Westminster, MD USA, where the final manufacture of all CTRL-branded hardware occurs.',
      },
      { type: 'h2', text: 'About Barfield Inc.' },
      {
        type: 'p',
        text:
          'Barfield consists of 400 employees across its facilities in Miami, Phoenix, Louisville and Atlanta. With its leading facilities, Barfield can satisfy the needs of customers operating commercial or regional fleets in North, Central and South America. From MRO Services to Distribution and Ground Support Test Equipment (GSTE), Barfield provides complete tailor-made support programs for A320 family, 737, Bombardier, Dash 8, ATR 42 & 72 and Embraer 170 & 190 aircraft to operators in need of inventory and logistics solutions, repair management programs, engineering and fleet support, and component reliability management. Barfield is part of the AFI KLM E&M network, a major MRO provider.',
      },
    ],
  },
];

export const getNewsPost = (slug) => newsPosts.find((p) => p.slug === slug);

export const formatNewsDate = (iso) =>
  new Date(`${iso}T12:00:00Z`).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'UTC',
  });
